import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const PortfolioHero = () => {
  const stats = [
    {
      value: "€127M",
      label: "Total Portfolio Value",
      icon: "TrendingUp",
      change: "+23.4%"
    },
    {
      value: "47",
      label: "Active Investments",
      icon: "Building2",
      change: "+8 this year"
    },
    {
      value: "12",
      label: "Successful Exits",
      icon: "Target",
      change: "3.2x avg return"
    },
    {
      value: "89%",
      label: "Success Rate",
      icon: "Award",
      change: "Industry leading"
    }
  ];

  return (
    <section className="relative bg-gradient-to-br from-slate-900 via-blue-900 to-slate-800 text-white overflow-hidden">
      <div className="absolute inset-0 morphing-gradient opacity-20"></div>
      <div className="relative max-w-7xl mx-auto px-6 py-20">
        <div className="text-center mb-16">
          <div className="inline-flex items-center space-x-2 bg-white/10 backdrop-blur-sm rounded-full px-4 py-2 mb-6">
            <Icon name="Briefcase" size={16} />
            <span className="text-sm font-medium">Investment Portfolio</span>
          </div>
          
          <h1 className="text-5xl md:text-6xl font-bold mb-6 leading-tight">
            Building Digital
            <span className="block text-gradient-brand">Futures Together</span>
          </h1>
          
          <p className="text-xl text-slate-300 max-w-3xl mx-auto mb-8 leading-relaxed">
            Discover our portfolio of innovative companies transforming industries through strategic investment, 
            operational expertise, and digital-first thinking. Each partnership represents our commitment to 
            sustainable growth and market leadership.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Button 
              variant="default" 
              className="bg-white text-slate-900 hover:bg-slate-100"
              iconName="Download"
              iconPosition="left"
            >
              Portfolio Report 2024
            </Button>
            <Button 
              variant="outline" 
              className="border-white text-white hover:bg-white/10"
              iconName="Play"
              iconPosition="left"
            >
              Watch Success Stories
            </Button>
          </div>
        </div>

        {/* Stats Grid */}
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6">
          {stats?.map((stat, index) => (
            <div 
              key={index}
              className="bg-white/10 backdrop-blur-sm rounded-brand p-6 text-center hover-lift stagger-1"
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              <div className="inline-flex items-center justify-center w-12 h-12 bg-white/20 rounded-brand-sm mb-4">
                <Icon name={stat?.icon} size={24} />
              </div>
              <div className="text-3xl font-bold mb-2 counter-animate">{stat?.value}</div>
              <div className="text-sm text-slate-300 mb-2">{stat?.label}</div>
              <div className="text-xs text-green-400 font-medium">{stat?.change}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PortfolioHero;